import { BlankImg } from "assets/images";
import CustomModal from "components/Modal/CustomModal";
import React, { useState, useEffect } from "react";
import HostUserMoreDetail from "./HostUserMoreDetail";
import ImgComponent from "components/imgComponent";

const HostAcceptedList = (props) => {
  const [hostProfile, setHostProfile] = useState();
  const [showUser, setShowUser] = useState(false);
  const handleCloseUser = () => setShowUser(false);
  const handleShowUser = () => setShowUser(true);

  const profilePicture = () => {
    const cloudinaryUrl = props?.hostDetails?.user?.profile_picture?.cloudinary_file;
    const fileUrl = props?.hostDetails?.user?.profile_picture?.file;

    // If no cloudinary file, use the direct file
    if (!cloudinaryUrl) {
      setHostProfile(fileUrl);
      return;
    }

    // Verify cloudinary URL is accessible
    fetch(cloudinaryUrl)
      .then(function (response) {
        if (response && response.status === 200) {
          setHostProfile(response.url);
        } else {
          setHostProfile(fileUrl);
        }
      })
      .catch(function (error) {
        console.log(error);
        setHostProfile(fileUrl);
      });
  };

  // Update profile picture whenever hostDetails changes (sorting/filtering)
  useEffect(() => {
    profilePicture();
  }, [
    props?.hostDetails?.user?.id, // Re-run when user ID changes
    props?.hostDetails?.user?.profile_picture?.cloudinary_file,
    props?.hostDetails?.user?.profile_picture?.file
  ]);

  return (
    <tr>
      <td className="image-title-wrapper">
        <ImgComponent
          className="host-pp-small"
          onClick={handleShowUser}
          src={
            props?.hostDetails?.user?.profile_picture?.file !== null
              ? hostProfile
              : BlankImg
          }
          alt="user"
        />{" "}
        <CustomModal
          showStatus={showUser}
          modalClass="profile_detail"
          clickStatus={handleCloseUser}
          buttonMessage="Close"
          closeStatus={handleCloseUser}
          title=" "
          message={
            <HostUserMoreDetail details={props?.hostDetails?.user?.id} />
          }
          secondMessage="none"
          secondButton={false}
        />
        <span>
          {props?.hostDetails?.user.first_name}{" "}
          {(props?.hostDetails?.user.last_name).charAt(0)}.
        </span>
      </td>
      <td>
        ${" "}
        {props?.hostDetails?.revenue !== null ? props?.hostDetails?.revenue : 0}
      </td>
      <td>
        ${" "}
        {props?.hostDetails?.earning != null ? props?.hostDetails?.earning : 0}
      </td>
      <td>{props?.hostDetails?.top_product}</td>
    </tr>
  );
};

export default React.memo(HostAcceptedList);